import _slicedToArray from "/codebuild/output/src756613865/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { __rest } from "tslib";
import React, { forwardRef, useState, useEffect } from "react";
import { useWindowSize } from "../../../shared/hooks";
import { breakpoints } from "../../../shared/constants";
import * as S from "../styles";
export var Header = forwardRef(function (e, r) {
  var t = e.className,
      a = e.children,
      s = __rest(e, ["className", "children"]);

  var o = a.mobile,
      i = a.desktop,
      l = a.hidden,
      _useState = useState(!1),
      _useState2 = _slicedToArray(_useState, 2),
      n = _useState2[0],
      d = _useState2[1],
      c = useWindowSize(),
      m = !!(null == c ? void 0 : c.width) && c.width < breakpoints.forTabletHorizontalUp;

  return useEffect(function () {
    d(!0);
  }, []), React.createElement(S.HeaderWrapper, Object.assign({
    className: t,
    ref: r
  }, s), n ? React.createElement(S.Header, null, m ? o : i) : null, React.createElement(S.HiddenWrapper, null, l));
});
export default Header;